import AdmissionsOfficerDU from './AdmissionsOfficerDU';
import OrganisationAdminDU from './OrganisationAdminDU';
import RegistrarDU from './RegistrarDU';
import StudentDU from './StudentDU';
import VerifierDU from './VerifierDU';

export default {
	AdmissionsOfficerDU,
	RegistrarDU,
	VerifierDU,
	OrganisationAdminDU,
	StudentDU
};
